import type React from 'react';

import * as styles from './styles';

import {
  type ChecklistFieldContent,
  ChecklistFieldType,
} from '@cobliteam/api-lib';

import {
  CaptionDefault,
  DescriptionListDefault,
  DescriptionTitle,
  PlaceholderText,
} from '@cobliteam/base-components';

import { ChecklistIcon } from '../ChecklistIcon/ChecklistIcon';

const getItemContent = (
  type: ChecklistFieldType,
  content: ChecklistFieldContent
) => {
  if (type === ChecklistFieldType.TEXT && 'value' in content && content.value) {
    return content.value;
  }

  if (
    type === ChecklistFieldType.CHECK &&
    'checked' in content &&
    content.checked
  ) {
    return 'Marcado como feito';
  }

  if ('options' in content) {
    const filteredCheckedOptions = content.options
      .filter((option) => option.checked)
      .map((option) => option.label);

    if (filteredCheckedOptions.length) {
      return filteredCheckedOptions.join(', ');
    }
  }

  return <PlaceholderText>Item não preenchido</PlaceholderText>;
};

export interface ChecklistReceivedItemProps {
  required: boolean;
  title: string;
  content: ChecklistFieldContent;
  type: ChecklistFieldType;
}

export const ChecklistReceivedItem: React.FC<ChecklistReceivedItemProps> = ({
  required,
  title,
  content,
  type,
}) => {
  const itemContent = getItemContent(type, content);

  return (
    <div className={styles.checklistReceivedItemWrapper}>
      <div className={styles.descriptionWrapper}>
        <div className={styles.checklistIcon}>
          <ChecklistIcon checklistType={type} />
        </div>
        <div className={styles.wrapper}>
          <div className={styles.descriptionAndDetails}>
            <DescriptionTitle>{title}</DescriptionTitle>
            {required && (
              <div className={styles.requiredText}>
                <CaptionDefault>Campo obrigatório</CaptionDefault>
              </div>
            )}
          </div>
          <div className={styles.titleItem}>
            <DescriptionListDefault>{itemContent}</DescriptionListDefault>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChecklistReceivedItem;
